import React, { useState } from 'react';
import PropTypes from 'prop-types';

// core
import { useGlobal } from '_core/hooks/useGlobal';
import { withLang } from '_core/hocs/withLang';
import { State } from '_core/components/State';
import { ModalOuter } from '_core/components/ModalOuter';
import { ModalInner } from '_core/components/ModalInner';
import { PaymentSteps } from '_core/views/PaymentSteps';
import { PaymentResult } from '_core/views/PaymentResult';


export const RawPaymentModal = (props) => {
  const {
    onClose,
    shop,
    product,
    document,
    getLangString: l
  } = props;
  const [result, setResult] = useState();

  const {
    request: { queue },
    config: { API_METHOD, REPLACE_CURRENCY }
  } = useGlobal();

  const rawOnClose = () => {
    setResult();
    onClose();
  };

  if (!product)
    return null;

  const getData = () => {
    const params = /^\d+$/.test(product) ? { id: product } : { path: product };
    
    params.currency = REPLACE_CURRENCY.SHOP_GOODS;
    
    if (shop) params.shop = shop;
    
    return queue(API_METHOD.GOODS_INFO, params);
  };

  return (
    <ModalOuter
      open
      fullWidth
      maxWidth="md"
      onClose={rawOnClose}
    >
      <ModalInner
        title={l('r.oplata')}
        content={
          result != null ? (
            <PaymentResult
              onRetry={() => setResult()}
              onClose={rawOnClose}
              {...result}
            />
          ) : (
            <State
              getProps={{ data: getData }}
              render={({ data }) => (
                <PaymentSteps
                  setResult={setResult}
                  onClose={rawOnClose}
                  goodsData={data}
                  shop={shop}
                  product={product}
                  document={document}
                />
              )}
            />
          )
        }
      />
    </ModalOuter>
  );
};

RawPaymentModal.defaultProps = {};

RawPaymentModal.propTypes = {
  // self props
  product: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
};

export const PaymentModal = withLang(RawPaymentModal);
